import { BigNumber } from '@ethersproject/bignumber';
import { abis, claims } from '@manifoldxyz/claim-contracts';
import { TransactionStepState, TxStepStatus } from './types';

export const SUPPORT_URL = 'https://forum.manifold.xyz/c/manifold-support/12';
export const CLAIM_FEE_PER_MINT = BigNumber.from(500000000000000); // 0.0005 ETH * 1e18;
export const CLAIM_FEE_PER_MERKLE_MINT = BigNumber.from(690000000000000); // 0.00069 ETH * 1e18;
export const CLAIM_FEE_ADDRESS = '0xd58F2402D104df9C8A8667e24a3A5C79f8EC66aA';
export const MANIFOLD_FEE_EXPLANATION =
  'Manifold charges a minimal fee for items collected through our apps while creators retain 100% of the revenue. This fee supports ongoing maintenance and future development.';
export const PROCESSING_FEES_EXPLANATION =
  'Processing fees include Ethereum network expenses and card payment fees, helping to maintain a secure and efficient user experience. This includes vital components such as fraud protection, transaction monitoring, currency exchange risk management, and responsive customer support.';
export const DELEGATION_REGISTRY_ADDRESS_V1 = '0x00000000000076a84fef008cdabe6409d2fe638b';
export const DELEGATION_REGISTRY_ADDRESS_V2 = '0x00000000000000447e69651d841bd8d104bed493';
export const SAVED_EMAIL_LOCAL_STORAGE_KEY = 'saved-email';
export const SAVED_RECIPIENT_ADDRESS_LOCAL_STORAGE_KEY = 'saved-recipient-address';
export const MAX_APPROVE = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';
export const AUTHENTICATED = 'm-authenticated';
export const UNAUTHENTICATED = 'm-unauthenticated';
const { CLAIM_EXTENSION_721_V7, CLAIM_EXTENSION_1155_V7 } = claims;
const { Claim1155V7ABI, Claim721V7ABI } = abis;
export const STUDIO_LINK_CAMPAIGN_AND_MEDIUM = 'utm_medium=post-checkout&utm_campaign=app-link';

export const CLAIM_EXTENSION_ABIS: { [_: string]: Record<string, unknown>[] } = {
  [CLAIM_EXTENSION_721_V7]: Claim721V7ABI,
  [CLAIM_EXTENSION_1155_V7]: Claim1155V7ABI,
};

/**
 * Default initial state for transaction steps
 * Used when creating new steps to ensure consistent state initialization
 */
export const DEFAULT_STEP_STATE: TransactionStepState = {
  status: TxStepStatus.Unstarted,
  descriptionByStatus: {
    [TxStepStatus.Unstarted]: '',
    [TxStepStatus.Pending]: '',
    [TxStepStatus.Confirming]: '',
    [TxStepStatus.Confirmed]: '',
    [TxStepStatus.Failed]: '',
  },
  error: undefined,
  warning: undefined,
  etherscanLink: undefined,
  txHash: undefined,
};

export const SWAP_APP_FEES = [];
